import React, { useMemo } from 'react'
import clsx from 'clsx'
import { Grid, Typography } from 'gu-ui-kit'
import styles from 'layouts/AuthLayout/subcomponents/Nav/Nav.module.scss'
import { NavLink, useLocation } from 'react-router-dom'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

export const Nav = ({ className = '' }) => {
  const pathGen = useGeneratePathI18n()
  const { t } = useTranslation()
  const breakpoint = useBreakpoint()
  const location = useLocation()

  const navOptions = useMemo(
    () => [
      {
        url: ROUTES.AUTH_LOGIN,
        label: t('auth::nav.login'),
      },
      {
        url: ROUTES.AUTH_REGISTRATION,
        label: t('auth::nav.register'),
      },
    ],
    [t],
  )
  return (
    <Grid className={clsx(styles['nav'], className)} cols={2} wrap={false}>
      {navOptions.map(({ url, label }) => (
        <Typography
          key={url}
          variant={!breakpoint.fb ? 'Body-Accent-30' : 'Body-Accent-40'}
          color={'Label-Secondary'}
          component={
            <NavLink
              activeClassName={styles['nav__link_active']}
              className={clsx(styles['nav__link'])}
              to={{ pathname: pathGen(url), search: location.search }}
            />
          }
        >
          {label}
        </Typography>
      ))}
    </Grid>
  )
}

Nav.propTypes = {
  className: PropTypes.string,
}
